import { TransactionType } from 'dashboard/models/transaction-type';
import Action from 'lib/interfaces/Action';

interface SetTransactionTypePayload {
  transactionType: TransactionType;
}

export type TransactionTypeActions =
  | Action<TransactionTypeActionType.SetTransactionType, SetTransactionTypePayload>
  | Action<TransactionTypeActionType.ClearTransactionType>;

export enum TransactionTypeActionType {
  SetTransactionType = 'transaction-type/SET_TRANSACTION_TYPE',
  ClearTransactionType = 'transaction-type/CLEAR_TRANSACTION_TYPE',
}

export function setTransactionType(
  transactionType: TransactionType,
): Action<TransactionTypeActionType.SetTransactionType, SetTransactionTypePayload> {
  return {
    payload: {
      transactionType,
    },
    type: TransactionTypeActionType.SetTransactionType,
  };
}

export function clearTransactionType(): Action<TransactionTypeActionType.ClearTransactionType> {
  return { type: TransactionTypeActionType.ClearTransactionType };
}
